import { useQuery } from "@apollo/client";

import { DEFAULT_REFERRAL_AMOUNT_IN_CENTS } from "@constants";
import { UserReferralDataQuery, UserReferralDataQueryVariables } from "@ctypes";
import { USER_REFERRAL_DATA } from "@graphql";
import { convertCentsToDollar, formatCurrency } from "@utils";

export const useReferralData = () => {
  const { data: queryData, ...rest } = useQuery<
    UserReferralDataQuery,
    UserReferralDataQueryVariables
  >(USER_REFERRAL_DATA);

  const data = queryData?.userReferralData;

  const referralAmount = formatCurrency(
    convertCentsToDollar(data?.referralAmountInCents ?? DEFAULT_REFERRAL_AMOUNT_IN_CENTS),
  );

  return { data, referralAmount, ...rest };
};
